export enum QuestionnaireTemplateType {
    Standard = 'Standard',
    Custom = 'Custom'
}